import { Grid, styled } from "@mui/material"

export const StyledGrid = styled(Grid)(({ theme }) => ({
  justifyContent: "space-between",
  backgroundColor: (theme.palette as any).foreground.inverted,
  borderRadius: "10px"
}))
